<app-dialog [showCloseBtn]="true" size="small">
  <div class="logout-dialog-header text-center" dialogContent>{{ 'REMOVE_ACCOUNT_SUCCESS' | translate }}</div>
</app-dialog>
